import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Loan Process',
    href: '#process'
  }, {
    name: 'Forms & Documents',
    href: '#forms',
    badge: true
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-md py-3' : 'bg-white/95 backdrop-blur-sm shadow-sm py-4'}`} data-id="element-371">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-372">
        <div className="flex items-center justify-between" data-id="element-373">
          {/* Logo */}
          <a href="#" className="flex items-center" data-id="element-374">
            <img src="https://cdn.magicpatterns.com/uploads/oG2uuGYn8jU9LyVa8StNpR/Logo_Cava_Transparent.png" alt="De Rien Financial Services" className="h-12 w-auto" data-id="element-375" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-376">
            {navLinks.map(link => <a key={link.name} href={link.href} className="flex items-center gap-1.5 text-navy hover:text-navy-light font-medium transition-colors text-sm whitespace-nowrap" data-id="element-377">
                {link.name}
                {link.badge && <span className="inline-flex items-center justify-center w-4 h-4 bg-gold rounded-full text-[10px] text-navy font-bold" data-id="element-378">
                    ✓
                  </span>}
              </a>)}
            <Button size="sm" variant="primary" onClick={() => window.location.href = '#apply'} data-id="element-379">
              Apply Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-navy" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-380">
            {isMobileMenuOpen ? <X size={24} data-id="element-381" /> : <Menu size={24} data-id="element-382" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg p-4 flex flex-col space-y-1" data-id="element-383">
          {navLinks.map(link => <a key={link.name} href={link.href} className="flex items-center justify-between text-navy font-medium py-3 px-2 border-b border-gray-50 hover:bg-gray-50 rounded" onClick={() => setIsMobileMenuOpen(false)} data-id="element-384">
              <span data-id="element-385">{link.name}</span>
              {link.badge && <span className="inline-flex items-center gap-1 bg-gold/20 text-navy text-xs font-semibold px-2 py-0.5 rounded-full" data-id="element-386">
                  <span className="text-navy-light" data-id="element-387">✓</span> Available
                </span>}
            </a>)}
          <div className="pt-2" data-id="element-388">
            <Button className="w-full" onClick={() => {
          setIsMobileMenuOpen(false);
          window.location.href = '#apply';
        }} data-id="element-389">
              Apply Now
            </Button>
          </div>
        </div>}
    </header>;
}